import { orderBy } from 'lodash';
/*
 * Decorates an account with calculated fields like
 * the closed/open dsa counts and the pinned status.
 */
export const decorateAccount = account => {
  let decoratedAccount = {...account};
  const lastUpdatedDSA = orderBy(account.dsas, 'updatedAt', 'desc')[0];
  decoratedAccount.updatedAt = lastUpdatedDSA ? lastUpdatedDSA.updatedAt : null;
  decoratedAccount.closedDSACount = account.dsas.filter(d => d.state === 'closed').length;
  decoratedAccount.openDSACount = account.dsas.filter(d => d.state !== 'closed').length;
  decoratedAccount.pinned = !!(account.pins && !!account.pins.length);

  if (!account.ivas) account.ivas = [];
  const lastUpdatedIVA = orderBy(account.ivas, 'updatedAt', 'desc')[0];
  decoratedAccount.ivaUpdatedAt = lastUpdatedIVA ? lastUpdatedIVA.updatedAt : null;
  decoratedAccount.closedIVACount = account.ivas.filter(d => d.state === 'closed').length;
  decoratedAccount.openIVACount = account.ivas.filter(d => d.state !== 'closed').length;

  if (!account.pvps) account.pvps = [];
  const lastUpdatedPVP = orderBy(account.pvps, 'updatedAt', 'desc')[0];
  decoratedAccount.pvpUpdatedAt = lastUpdatedPVP ? lastUpdatedPVP.updatedAt : null;
  decoratedAccount.closedPVPCount = account.pvps.filter(d => d.state === 'closed').length;
  decoratedAccount.openPVPCount = account.pvps.filter(d => d.state !== 'closed').length;

  return decoratedAccount;
};


/*
 * Takes the current visible account state and decorates it
 */
export const getVisibleAccount = state => {
  let visibleAccount = {...state.account};
  visibleAccount.data = decorateAccount(visibleAccount.data);
  return visibleAccount;
};




// WEBPACK FOOTER //
// ./src/selectors/account/accountSelectors.js